var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75038 10.367V2.80371C1.48364 2.87432 1.21686 2.96064 0.96582 3.03908V12.5874C3.07178 12.0053 5.30961 12.1209 7.34441 12.9169C5.96163 11.5187 4.07774 10.7307 2.11131 10.7279C1.91371 10.7238 1.75457 10.5646 1.75038 10.367Z",
    fill: "#35435E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48838 0.741211L2.46484 10.0462C4.77436 10.1658 6.92831 11.2471 8.40406 13.0276V4.15411C7.05674 2.17286 4.87792 0.915864 2.48838 0.741211Z",
    fill: "#35435E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7473 2.81934V10.3748C15.7431 10.5723 15.5839 10.7315 15.3864 10.7357C13.4243 10.7374 11.5449 11.5259 10.1689 12.9246V12.9325C12.197 12.1336 14.4292 12.0125 16.5318 12.5872V3.05467C16.2808 2.96839 16.0219 2.88211 15.7473 2.81934Z",
    fill: "#35435E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0408 0.741211C12.6416 0.898506 10.451 2.159 9.10938 4.15411V13.0276C10.5833 11.249 12.734 10.168 15.0408 10.0462V0.741211Z",
    fill: "#35435E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.fec8309748d885246e7eec4e431a121b.svg";
export { ForwardRef as ReactComponent };